import React from 'react';
import { classNames } from '../../utils/classNames';
import { ModelSelect } from '../../features/chat/ModelSelect';
import { useI18n } from '../../hooks/useI18n';

export const ModalComposerField = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  model,
  onModelChange,
  showModelSelect = true,
  showIncludesImageBadge = false,
  error = '',
  className,
  textareaClassName
}) => {
  const { t } = useI18n();

  return (
    <div className={classNames('space-y-1.5', className)}>
      {label ? (
        <span className="text-sm font-medium text-muted">
          {label}
          {required ? <span className="text-rose-500"> *</span> : null}
        </span>
      ) : null}

      <div
        className={classNames(
          'rounded-xl border border-border bg-white/55 dark:bg-slate-950/20',
          !disabled && 'focus-within:border-accent/40'
        )}
      >
        <label className="sr-only" htmlFor={id}>
          {label}
        </label>
        <textarea
          id={id}
          value={value}
          disabled={disabled}
          required={required}
          placeholder={placeholder}
          rows={3}
          onChange={(event) => onChange(event.target.value)}
          className={classNames(
            'block min-h-[5.5rem] w-full resize-none border-0 bg-transparent px-3 py-2.5 text-sm leading-5 text-text outline-none placeholder:text-muted/75 disabled:cursor-not-allowed disabled:opacity-60',
            textareaClassName
          )}
        />

        {showIncludesImageBadge || showModelSelect ? (
          <div className="flex items-center gap-1.5 px-1.5 pb-1.5">
            {showIncludesImageBadge ? (
              <span className="inline-flex rounded-full border border-accent/30 bg-accent-soft/70 px-2 py-0.5 text-[10px] font-medium text-accent">
                {t('includesImageBadge')}
              </span>
            ) : null}
            {showModelSelect ? (
              <div className="ms-auto flex shrink-0 items-center">
                <ModelSelect compact portal showBadge value={model} onChange={onModelChange} disabled={disabled} />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>

      {error ? (
        <p className="text-xs text-rose-600 dark:text-rose-300" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
};
